import { listenerMiddleware } from 'legacy/lut/store/middlewares/listenerMiddleware'

import { requestCommitmentItems } from '../api/requestCommitmentItems'
import { requestCommitmentStatuses } from '../api/requestCommitmentStatuses'
import {
  commitmentItemsFulfilled,
  commitmentItemsPending,
  commitmentItemsRejected,
  commitmentStatusesFulfilled,
  commitmentStatusesPending,
  commitmentStatusesRejected,
} from '../commitmentDataLifecycle'

listenerMiddleware.startListening({
  actionCreator: requestCommitmentItems.pending,
  effect: (_, { dispatch }) => {
    dispatch(commitmentItemsPending())
  },
})

listenerMiddleware.startListening({
  actionCreator: requestCommitmentItems.rejected,
  effect: (action, { dispatch }) => {
    dispatch(commitmentItemsRejected(action.error.message))
  },
})

listenerMiddleware.startListening({
  actionCreator: requestCommitmentItems.fulfilled,
  effect: (action, { dispatch }) => {
    dispatch(commitmentItemsFulfilled(action.payload))
  },
})

listenerMiddleware.startListening({
  actionCreator: requestCommitmentStatuses.pending,
  effect: (_, { dispatch }) => {
    dispatch(commitmentStatusesPending())
  },
})

listenerMiddleware.startListening({
  actionCreator: requestCommitmentStatuses.rejected,
  effect: (action, { dispatch }) => {
    dispatch(commitmentStatusesRejected(action.error.message))
  },
})

listenerMiddleware.startListening({
  actionCreator: requestCommitmentStatuses.fulfilled,
  effect: (action, { dispatch }) => {
    dispatch(commitmentStatusesFulfilled(action.payload))
  },
})
